import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Address, Attributes, ListingPrice } from '~/components/ListingCard';
import { RoutesEnum } from '~/constants/enums';
import { ListingsResponseType } from '~/types/listingTypes';

export default function StackedListingCard({
  listing,
  section,
}: {
  listing: ListingsResponseType;
  // The related-listings payload carries neither a section nor a usable slug,
  // so both come from the listing the page was opened for — the same way the
  // listing details page builds its related cards.
  section: { slug: string };
}) {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;
  const slug = `${section.slug}-${listing.location.slug.split('/').join('-')}`;
  const listingRoute = `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LISTING}/${listing.id}-${slug}`;
  const photo = listing.photos?.[0]?.thumbnails?.thumb;

  return (
    <article className="flex h-full flex-col overflow-hidden rounded-[12px] border border-gray bg-white">
      <a
        href={listingRoute}
        target="_blank"
        rel="noopener noreferrer"
        className="block h-[192px] w-full shrink-0 bg-gray_light_1"
      >
        {photo ? (
          <img
            src={photo}
            alt={listing.title}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="element-center h-full w-full text-gray__dark_1">
            <Icon name="image-placeholder" size="56px" />
          </div>
        )}
      </a>
      <a
        href={listingRoute}
        target="_blank"
        rel="noopener noreferrer"
        className="flex min-w-0 flex-1 flex-col gap-x p-1.5x md:p-2x"
      >
        <ListingPrice
          price={listing.price}
          area={listing.area}
          section={section.slug}
          showPricePerMeter
        />
        <p
          className="line-clamp-2 text-caption text-black"
          title={listing.title}
        >
          {listing.title}
        </p>
        <Address address={listing.address} />
        <Attributes
          listing={{
            area: listing.area,
            attributes: {
              rooms: listing.attributes?.rooms
                ? parseInt(listing.attributes.rooms, 10)
                : undefined,
              baths: listing.attributes?.baths
                ? parseInt(listing.attributes.baths, 10)
                : undefined,
            },
          }}
        />
      </a>
    </article>
  );
}
